
import { GlobalController } from 'src/shared/global/GlobalController'
import BalanceComponentGroup from './BalanceComponentGroup'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'balanceComponentGroup',
    component: BalanceComponentGroup,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
